import { Row, Col } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import {
    useTable,
    useSortBy,
    useGlobalFilter
} from "react-table";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export function FullTable({
    columns,
    data,
    tableHeight,
    color = "#000",
}) {
    const navigate = useNavigate();

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        useSortBy
    );

    return (
        <div className="table-design">
            <BTable
                size="sm"
                responsive
                bordered
                {...getTableProps()}
                className="custom-table mb-0"
            >
                <style>
                    {`
.table-responsive {
   
    overflow-y: auto;
    overflow-x: auto;
    padding-bottom: 175px;
    padding-top: 47px;
    padding-left: 10px;
    padding-right: 10px;
}

.custom-table {
    border: 2px solid #d8d8d8 !important;
    border-collapse: collapse !important;
    width: 100%;
    background-color: #fff !important;
}

.custom-table th,
.custom-table td {
    border: 2px solid #d8d8d8 !important;
    text-align: left;
    vertical-align: middle;
    padding: 0px 4px !important;
    line-height: 1.3 !important;
}

/* HEADER COLOR */
.custom-table thead th {
    background-color: #F0EDE6 !important;
    position: sticky;
    top: -1px;
}

/* ALTERNATE ROW COLORS */
.custom-table tbody tr:nth-child(odd) {
    background-color: #ffffff !important;
}

.custom-table tbody tr:nth-child(even) {
    background-color: #F0EDE6 !important;
}

/* Hover */
.custom-table tbody tr:hover {
    background-color: #e6e2d8 !important;
}
`}
                </style>

                <thead>
                    {headerGroups.map((headerGroup, ind) => (
                        <tr {...headerGroup.getHeaderGroupProps()} key={ind}>
                            {headerGroup.headers.map((column, indx) => (
                                <th
                                    className="px-2 text-center"
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    key={indx}
                                    style={{
                                        verticalAlign: "middle",
                                        textAlign: "left",
                                    }}
                                >
                                    <h4 className="f3 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 py-1 primary">
                                        {column.Header === "Commission Amount" ? (
                                            <>Commission<br />Amount</>
                                        ) : column.Header === "Betting Amount" ? (
                                            <>Betting<br />Amount</>
                                        ) : (
                                            column.render("Header")
                                        )}
                                    </h4>

                                    {column.isSorted &&
                                        (column.isSortedDesc ?
                                            <span className="feather icon-arrow-down text-muted float-right" /> :
                                            <span className="feather icon-arrow-up text-muted float-right" />)}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                    {rows.length === 0 ? (
                        <tr>
                            <td
                                colSpan={columns.length}
                                className="text-center py-3"
                                style={{
                                    color: "#666",
                                    fontWeight: "600",
                                    backgroundColor: "#F0EDE6",
                                    fontSize: "14px",
                                }}
                            >
                                No data
                            </td>
                        </tr>
                    ) : (
                        rows.map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr
                                    className="f2"
                                    {...row.getRowProps()}
                                    key={i}
                                    style={{
                                        backgroundColor: i % 2 === 0 ? "#ffffff" : "#F0EDE6",
                                    }}
                                >

                                    {row.cells.map((cell, ind) => {
                                        const columnKey = cell.column.id;
                                        let cellValue = cell.value;

                                        if (columnKey === "lot_details" && cellValue != null) {
                                            const text = cellValue || "";
                                            const match = text.match(/\b(dear|kerala)\b/i);
                                            let firstLine = text.trim();
                                            let secondLine = "";

                                            if (match) {
                                                const index = match.index;
                                                firstLine = text.substring(0, index).trim();
                                                secondLine = text.substring(index).trim();
                                            }

                                            cellValue = (
                                                <div
                                                    className="tbel-s"
                                                    style={{
                                                        whiteSpace: "pre-line",
                                                        textTransform: "uppercase",
                                                        lineHeight: "1.2",
                                                        minWidth: "150px",
                                                        wordWrap: "break-word",
                                                    }}
                                                >
                                                    <div>{firstLine}</div>
                                                    {secondLine && <div>{secondLine}</div>}
                                                </div>
                                            );
                                        } else {
                                            cellValue = cell.render("Cell");
                                        }

                                        return (
                                            <td
                                                {...cell.getCellProps()}
                                                key={ind}
                                                style={{
                                                    color: color,
                                                    textAlign: "left",
                                                    verticalAlign: "middle",
                                                    backgroundColor: i % 2 === 0 ? "#ffffff" : "#F0EDE6",   // ✅ add this
                                                }}
                                                className="fs-xs-14 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 px-2 py-1 gray2 list-data"
                                            >
                                                {cellValue}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </BTable>
        </div>
    );
}
